/*
 * Attachment utils
 */

const utils = function (params) {
  return {
    methods: {
      createFileFromBase64Uri(imageBytes) {
        var byteString
        if (imageBytes.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(imageBytes.split(',')[1])
        else
          byteString = unescape(imageBytes.split(',')[1])

        var mimeString = imageBytes
          .split(',')[0]
          .split(':')[1]
          .split(';')[0]

        var extension = mimeString.split('/')[1]
        var fileName = 'capture.' + extension

        var ia = new Uint8Array(byteString.length)
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }

        var blob = new Blob([ia], {
          type: mimeString
        })

        return new File([blob], fileName, {
          type: mimeString
        })
      },
      checkImage(imageSrc, good, bad) {
        let img = new Image()
        img.onload = good
        img.onerror = bad
        img.src = imageSrc
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      }
    },
  }
}

export default utils
